import util from '../util'

let controller = 'RecursosPix'
export default Object.assign({}, {
  Transferir: function (dto) {
    return util.Axios.Post(controller + '/Transferir', dto)
  },
  Devolver: function (dto) {
    return util.Axios.Post(controller + '/Devolver', dto)
  },
  ConsultarRecursosRecebidos: function (dto) {
    return util.Axios.GetAll(controller + '/ConsultarRecursosRecebidos', dto, true)
  },
  BuscarSaldoContaReservaPix: function () {
    return util.Axios.Get(controller + '/BuscarSaldoContaReservaPix')
  },
  BuscarSaldoContaReserva: function () {
    return util.Axios.Get(controller + '/BuscarSaldoContaReserva')
  },
  StatusTransferir: function (codigoTransacao) {    
    return util.Axios.Get(controller + '/Transferir/Status', codigoTransacao)
  },
  StatusDevolver: function (codigoTransacao) {
    return util.Axios.Get(controller + '/Devolver/Status', codigoTransacao)
  }
})
